import { render, staticRenderFns } from "./TopDealsSlider.vue?vue&type=template&id=9bdee9f8&scoped=true"
import script from "./TopDealsSlider.vue?vue&type=script&lang=js"
export * from "./TopDealsSlider.vue?vue&type=script&lang=js"
import style0 from "./TopDealsSlider.vue?vue&type=style&index=0&id=9bdee9f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdee9f8",
  null
  
)

export default component.exports